var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"container"},[_c('topPart'),_c('home-banner',{ref:"homeBanner",attrs:{"height":540}}),_c('router-view'),_c('bottomPart')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }